module.exports = __webpack_public_path__ + "static/img/yylt71.30a8dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yylt71.png
// module id = VVNP
// module chunks = 73